import axios from "axios";
import { getTenantSlug } from "@/lib/tenant";

export const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const UNIT_KEY = "unit_id";

export const getUnitId = () => localStorage.getItem(UNIT_KEY);
export const setUnitId = (u) => (u ? localStorage.setItem(UNIT_KEY, u) : localStorage.removeItem(UNIT_KEY));
export const fileUrl = (path) => `${BASE}/files/${encodeURIComponent(path)}`;

let onUnauthorized = () => {};
export const setUnauthorizedHandler = (fn) => (onUnauthorized = fn);

const http = axios.create({ baseURL: BASE, withCredentials: true });
http.interceptors.request.use((cfg) => {
  const u = getUnitId();
  if (u) cfg.headers["X-Unit-Id"] = u;
  const t = getTenantSlug();
  if (t) cfg.headers["X-Tenant"] = t;
  return cfg;
});

let refreshing = null;
export const refreshSession = () => {
  refreshing = refreshing || http.post("/auth/refresh").finally(() => (refreshing = null));
  return refreshing;
};
const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];

http.interceptors.response.use(null, async (e) => {
  const cfg = e.config || {};
  if (e?.response?.status !== 401 || cfg._retried || NO_RETRY.includes(cfg.url)) throw e;
  cfg._retried = true;
  try {
    await refreshSession();
  } catch {
    if (cfg.url !== "/auth/me") onUnauthorized();
    throw e;
  }
  return http.request(cfg);
});

function formatDetail(d) {
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || "Verifique os campos preenchidos";
  if (d && typeof d.message === "string") return d.message;
  return "Algo deu errado. Tente novamente.";
}

export const errorMessage = (e) => (e?.response ? formatDetail(e.response.data?.detail) : "Erro de conexão");

export async function api(path, { method = "GET", body, form, responseType } = {}) {
  try {
    const res = await http.request({ url: path, method, data: form || body, responseType });
    return res.data;
  } catch (e) {
    const err = new Error(errorMessage(e));
    err.status = e?.response?.status;
    err.detail = e?.response?.data?.detail;
    throw err;
  }
}

export const LOSS_REASONS = ["Vencimento", "Quebra/Avaria", "Erro de preparo", "Sobra/Descarte", "Outro"];
export const UNITS = ["un", "kg", "g", "L", "ml", "cx", "pct", "dz"];
